import React from 'react';

const BrandingProcess = () => {
  const processSteps = [
    {
      step: 1,
      title: "Research & Strategy",
      features: [
        "Understanding your business, audience & competitors",
        "Developing a brand positioning strategy"
      ]
    },
    {
      step: 2,
      title: "Visual Identity & Design",
      features: [
        "Logo, color scheme & typography selection",
        "Designing marketing & brand assets"
      ]
    },
    {
      step: 3,
      title: "Implementation & Brand Launch",
      features: [
        "Applying branding across digital & print platforms",
        "Creating a brand launch campaign for maximum visibility"
      ]
    }
  ];

  return (
    <div className="bg-gray-900 text-white py-12 px-4"
    style={{ backgroundColor: 'black' }}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 flex items-center">
          <span className="bg-yellow-500 text-gray-900 p-2 rounded-full mr-3 text-xl">!</span>
          Our Branding Process
        </h2>

        <div className="relative">
          {processSteps.map((process, idx) => (
            <div key={idx} className="mb-12 relative">
              <div className="flex items-start">
                <div className="bg-yellow-500 text-gray-900 rounded-full w-12 h-12 flex items-center justify-center font-bold text-xl mr-6">
                  {process.step}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-4">{process.title}</h3>
                  <ul className="space-y-3">
                    {process.features.map((feature, featureIdx) => (
                      <li key={featureIdx} className="flex items-start">
                        <span className="text-yellow-500 mr-2 mt-1 flex-shrink-0 text-lg font-bold">✓</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              {idx < processSteps.length - 1 && (
                <div className="absolute left-6 top-14 h-16 flex items-center">
                  <div className="h-full w-0.5 bg-yellow-500"></div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-6">
        </div>
      </div>
    </div>
  );
};

export default BrandingProcess;